import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SafeResourceUrlPipe } from './safe-resource-url.pipe';

@NgModule({
    declarations: [SafeResourceUrlPipe],
    imports: [CommonModule],
    exports: [SafeResourceUrlPipe]
})
export class SharedPipesModule {}
